/* eslint-disable no-undef */
/* eslint-disable no-console */

/**
 * Smooth scroll - 1 - Start.
 */
var hash = window.location.hash;
if ( hash ) {

	// if coming from another page
	// store the hash (DON'T put this code inside the $() function, it has to be executed
	// right away before the browser can start scrolling!

	var AnchorSeed = new Date() * 1;
    jQuery( ".AnchorUpdate" ).each(
        function() {
            jQuery( this ).attr( "id", this.id + AnchorSeed );
        }
	);
}
/**
 * Smooth scroll - 1 - Finish.
 */



(function ($) {
	"use strict";



	$(function () {

		// https://www.npmjs.com/package/screen-size-detector
		let intViewportWidth = window.innerWidth; // Use Web API.
		// let intViewportHeight = window.innerHeight; // Use Web API.

		// console.log(
		// 	"Width: " +
		// 		intViewportWidth +
		// 		", Height: " +
		// 		intViewportHeight
		// );



		/**
		 * Desktop mega menu, button click background overlay.
		 */
		if (intViewportWidth >= 992) {
			/**
			 * If mega menu desktop menu is displaying.
			 */

			$(document).on('click', function (e) {

				setTimeout(function () {
					/**
					 * Pause 200ms to allow the mega menu to open.
					 */

					if ($('#mega-menu-wrap-primary li').hasClass('mega-toggle-on')) {
						$('body').addClass('mega-menu-primary-desktop-open');
					} else {
						if ($('body').hasClass('mega-menu-primary-desktop-open')) {
							$('body').removeClass('mega-menu-primary-desktop-open');
						}
					}

				}, 100);

			});

		} else {
			/**
			 * If mega menu mobile menu is displaying.
			 */

			$(document).on('click', 'ul#mega-menu-primary > li > a', function (e) {
				/**
				 * If click registered on top level link.
				 */

				/**
				 * Find other top level links and close their sub-menus.
				 */
				$(this).parent().siblings().removeClass('mega-toggle-on');

			});
		}



		function ischanged($this_checkboxes, $this_silder) {

			var selected = [];
			$('input:checked', $this_checkboxes).each(function () {
				selected.push($(this));
			});

			if (selected.length === 0) {
				$($this_silder + '_price .right').hide();
			} else {
				$($this_silder + '_price .right').show();

				if (selected.length === 1) {
					// Only one checkbox is checked.

					var revis = '', price = '', max = '';

					if (selected[0].data('revis')) {
						revis = '£' + selected[0].data('price');

						$($this_silder + "_price.column-price .revis-target").html(revis).show();

						price = '£' + selected[0].data('revis');
					} else {

						$($this_silder + "_price.column-price .revis-target").hide();

						price = '£' + selected[0].data('price');
					}

					$($this_silder + "_price.column-price .price-target").html(price).show();
				} else {
					// More than one checkbox is checked.

					var revis = '', price = '', max = '';

					if ($this_checkboxes.data('joint-price-discounted')) {
						if (parseInt( $this_checkboxes.data('joint-price-discounted') ) > 0) {
							revis = '£' + $this_checkboxes.data('joint-price');
							$($this_silder + "_price.column-price .revis-target").html(revis).show();
						} else {
							$($this_silder + "_price.column-price .revis-target").hide();
						}

						price = '£' + $this_checkboxes.data('joint-price-discounted');
					} else {
						$($this_silder + "_price.column-price .revis-target").hide();
						price = '£' + $this_checkboxes.data('joint-price');
					}

					$($this_silder + "_price.column-price .price-target").html(price).show();

				}
			}
		}


		function update(value = 0, event) {

			var $this_silder = '#' + $(event.target).attr('id');
			var $this_left_string = $($this_silder + '_price').find('.learners-target').data('left-string');
			var $this_right_string = $($this_silder + '_price').find('.learners-target').data('right-string');

			if (
				$($this_silder).closest('.column-range').data('pricing-type') !== 'checkbox'
			) {
				// Slider

				if (
					$($this_silder).data('counter') > 1
				) {
					// Show the slider if applicable.
					$($this_silder).closest('.column-range').show();
				}

				$('li', $this_silder).removeClass('active');

				$('li', $this_silder).each(function (i, li) {
					var $this = $(this);
					var revis = '', price = '', max = '';

					if ($(this).data('step') == value) {

						if ($this_left_string.length > 0) {
							max = '<strong>' + $this_left_string + '</strong> / ' + $this_right_string;
						} else {
							max = '<strong>' + ($(this).data('max') >= 1 ? $(this).data('max') + ' Learner' + ($(this).data('max') > 1 ? 's' : '') : 'Unlimited accounts') + '</strong> / ' + $this_right_string;
						}

						$($this_silder + "_price.column-price .learners-target").html(max);

						if ($(this).data('revis')) {
							revis = '£' + $(this).data('price');

							$($this_silder + "_price.column-price .revis-target").html(revis).show();

							price = '£' + $(this).data('revis');
						} else {
							price = '£' + $(this).data('price');
						}

						$($this_silder + "_price.column-price .price-target").html(price).show();
					}

					if ($(this).data('step') <= value) {
						$(li).addClass('active');
					}
				});

			} else if (
				$($this_silder).closest('.column-range').data('pricing-type') === 'checkbox'
			) {

				var $this_checkboxes = $($this_silder).closest('.column-range').siblings('.column-checkbox').show();

				$('input', $this_checkboxes).each(function (i, li) {

					var revis = '', price = '', max = '';

					if ($(this).data('step') == value) {

						if ($this_left_string.length > 0) {
							max = '<strong>' + $this_left_string + '</strong> / ' + $this_right_string;
						} else {
							max = '<strong>' + ($(this).data('max') > 1 ? $(this).data('max') + ' Learner' + ($(this).data('max') > 1 ? 's' : '') : 'Unlimited accounts') + '</strong> / ' + $this_right_string;
						}

						$($this_silder + "_price.column-price .learners-target").html(max);

						if ($(this).data('revis')) {
							revis = '£' + $(this).data('price');

							$($this_silder + "_price.column-price .revis-target").html(revis).show();

							price = '£' + $(this).data('revis');
						} else {
							price = '£' + $(this).data('price');
						}

						$($this_silder + "_price.column-price .price-target").html(price).show();
					}

				});

				$("input[type=checkbox]", $this_checkboxes).on('change', function (e) {
					var $this = $(this);
					ischanged($this_checkboxes, $this_silder);
				});

			}

		}


		if ($(".tasks_time").length > 0) {

			$('.tasks_time').each(function (i, li) {

				var counter = $(li).data('counter');

				var myslider = $(li).slider({
					range: "min",
					value: 0,
					min: 0,
					max: counter - 1,
					step: 1,
					slide: function (event, ui) {
						update(ui.value, event);
					},
					create: function (event, ui) {
						update(ui.value, event);
					}
				});

			});

		}



		if ($(".mobile_number").length > 0) {

			/**
			 * Fees mobile number field
			 * https://codepen.io/Tanya_Rybachuk/pen/jyxzEp
			 */

			$('.minus').click(function () {

				// Get the parent data attributes.
				var $this_number = $(this).parent();

				if ( parseInt( $this_number.data('counter' ) ) > 1 ) {
					/**
					 * Only process if number (range slider) has more than one step.
					 */

					var step_number  = $this_number.data('step-number');
					var step_number_array  = step_number.split(',');
					var max_number   = $this_number.data('max-number');
					var max_number_array   = max_number.split(',');
					var price_number = $this_number.data('price-number');
					var price_number_array = price_number.split(',');
					var revis_number = $this_number.data('revis-number');
					var revis_number_array = revis_number.split(',');

					var $this_step = parseInt( $this_number.find('input').data('this-step') );

					// If this_step is greater than 0 then minus 1.
					if ( $this_step > 0 ) {
						$this_step--;

						var $input = $this_number.find('input');
						$this_number.find('input').data('this-step', $this_step);

						/**
						 * If this_step is equal than 0 then make '.minus' disabled via CSS.
						 */
						if ( parseInt( $this_number.find('input').data('this-step') ) === 0) {
							$this_number.find('.minus').addClass('disabled');
						}

						/**
						 * If this_step is not equal to step_number_array[ step_number_array.length - 1 ]
						 * then make '.plus' disabled via CSS.
						 */
						if ($this_number.find('input').data('this-step') !== parseInt( step_number_array[ step_number_array.length - 1 ] ) ) {
							$this_number.find('.plus').removeClass('disabled');
						}

						$input.val(parseInt( max_number_array[$this_step] ) );

						var $this_column_price = $this_number.parent().parent().find('.column-price');
						var $this_left_string  = $this_column_price.find('.learners-target').data('left-string');
						var $this_right_string = $this_column_price.find('.learners-target').data('right-string');

						var revis = '', price = '', max = '';

						if ($this_left_string.length > 0) {
							max = '<strong>' + $this_left_string + '</strong> / ' + $this_right_string;
						} else {
							max = '<strong>' + (max_number_array[$this_step] >= 1 ? max_number_array[$this_step] + ' Learner' + (max_number_array[$this_step] > 1 ? 's' : '') : 'Unlimited accounts') + '</strong> / ' + $this_right_string;
						}

						$this_column_price.find(".learners-target").html(max);

						if (revis_number.length > 0) {

							revis = '£' + price_number_array[$this_step];
							$this_column_price.find(".revis-target").html(revis).show();
							price = '£' + revis_number_array[$this_step];

						} else {

							price = '£' + price_number_array[$this_step];

						}

						$this_column_price.find(".price-target").html(price).show();

					}

				}

				return false;
			});

			$('.plus').click(function () {

				// Get the parent data attributes.
				var $this_number = $(this).parent();

				if ( parseInt( $this_number.data('counter' ) ) > 1 ) {
					/**
					 * Only process if number (range slider) has more than one step.
					 */

					var step_number  = $this_number.data('step-number');
					var step_number_array  = step_number.split(',');
					var max_number   = $this_number.data('max-number');
					var max_number_array   = max_number.split(',');
					var price_number = $this_number.data('price-number');
					var price_number_array = price_number.split(',');
					var revis_number = $this_number.data('revis-number');
					var revis_number_array = revis_number.split(',');

					var $this_step = parseInt( $this_number.find('input').data('this-step') );

					// If this_step is less than last-step value then plus 1.
					if ( $this_step < parseInt( step_number_array[ step_number_array.length - 1 ] ) ) {
						$this_step++;

						var $input = $this_number.find('input');
						$this_number.find('input').data('this-step', $this_step);

						/**
						 * If this_step is greater than 0 then make '.minus' enabled via CSS.
						 */
						if ( parseInt( $this_number.find('input').data('this-step') ) !== 0) {
							$this_number.find('.minus').removeClass('disabled');
						}

						/**
						 * If this_step is equal to step_number_array[ step_number_array.length - 1 ]
						 * then make '.plus' disabled via CSS.
						 */
						if ($this_number.find('input').data('this-step') === parseInt( step_number_array[ step_number_array.length - 1 ] ) ) {
							$this_number.find('.plus').addClass('disabled');
						}

						$input.val(parseInt( max_number_array[$this_step] ) );

						var $this_column_price = $this_number.parent().parent().find('.column-price');
						var $this_left_string  = $this_column_price.find('.learners-target').data('left-string');
						var $this_right_string = $this_column_price.find('.learners-target').data('right-string');

						var revis = '', price = '', max = '';

						if ($this_left_string.length > 0) {
							max = '<strong>' + $this_left_string + '</strong> / ' + $this_right_string;
						} else {
							max = '<strong>' + (max_number_array[$this_step] >= 1 ? max_number_array[$this_step] + ' Learner' + (max_number_array[$this_step] > 1 ? 's' : '') : 'Unlimited accounts') + '</strong> / ' + $this_right_string;
						}

						$this_column_price.find(".learners-target").html(max);

						if (revis_number.length > 0) {

							revis = '£' + price_number_array[$this_step];
							$this_column_price.find(".revis-target").html(revis).show();
							price = '£' + revis_number_array[$this_step];

						} else {

							price = '£' + price_number_array[$this_step];

						}

						$this_column_price.find(".price-target").html(price).show();

					}

				}

				return false;
			});

		}

	});

	$(window).load(function () {

		// let intViewportWidth = window.innerWidth; // Use Web API.
		// let intViewportHeight = window.innerHeight; // Use Web API.

		if ($(".g__testimonials_block .slideshow").length > 0) {

			$('.g__testimonials_block .slideshow').slick({
				slidesToShow: 3,
				slidesToScroll: 1,
				focusOnSelect: true,
				arrows: true,
				dots: true,
				fade: false,
				adaptiveHeight: true,
				autoplay: false,
				autoplaySpeed: 4000,
				speed: 600,
				infinite: true,
				centerMode: true,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
							centerMode: false,
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                        }
                     },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                    // You can unslick at a given breakpoint now by adding:
                    // settings: "unslick"
                    // instead of a settings object
                ]
			});

			$('.g__testimonials_block .slideshow .slide').show();

		}

	});

})(jQuery);